export class Conditional_action
{
    constructor(data)
    {
        this.action = data.action;

        if ('condition' in data)
            this.condition = data.condition;
        else
            this.condition = null;

        // if condition was granted on the last round it is True
        // and means that there is no need to perform an action for the second time if condition remains true
        this.granted_last_round = false;
    }
}